<template>
  <div style="margin:20px">

    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Planned - Driver Utilization Weekly</span><br/>
      <span style="font-style: italic; font-size: 18px">this view shows the drivers scheduled by date over the next week, click the driver to see more details</span>
    </div>

    <div style="position: relative" class="align-right d-flex align-items-center justify-content-center">
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(-1)"><</a>
      &nbsp;&nbsp;<date-picker style="font-size: 20px; font-weight: bold; width:140px" v-model="details_fromDate" :config="options" :placeholder="details_fromDate"></date-picker>&nbsp;&nbsp;
      <a href="#" class="arrows" v-on:click.prevent="shift_detail_graph_date(1)">></a>
    </div>
    <br/>
    <div v-if="!loading">
      <div class="row" style="margin: 10px; font-weight: bold; font-size: 20px;">
        <template v-for="type_stat in summary.driver_type_stats">
          <div @click="filter_by_type(type_stat.type)" class="col" :style="{ 'background': type_stat.color }">{{type_stat.type}}</div>
        </template>
      </div>
      <br/>
      <div class="align-right d-flex justify-content-center" style='display: flex; flex-wrap: nowrap'>
        <div  style="min-width: 250px; max-width: 250px !important; border: 1px solid black; margin-top:5px" v-for="(day_record,day_idx) in items">
          <div style="background-color: #eee; border-bottom: 2px solid black;font-weight: bold; font-size:22px; text-align:center">{{day_record.date_month}}/{{day_record.date_day}} - {{day_record.date_weekday}}</div>
          <template v-if="!selected_type || selected_type==driver.driver_type" v-for="driver in day_record.drivers">
            <div style="text-align: center; margin: 2px; padding: 4px;" :style='getStyleForDriverID(driver.colorcode)' v-on:click="toggle_div(driver.driver)"><b>{{driver.driver}}</b></div>
            <div :style="driver_expanded == driver.driver ? 'text-align: left;min-height: 200px; border: 1px dotted darkgrey; margin: 8px; padding: 2px;' : 'display:none'">
              <span v-for="item,idx in driver.assignments">
                  <div style="margin: 5px !important">
                    <div v-if="item.charterID">
                        <hr v-if="idx > 0"/>
                      <b>BookingID:</b> {{item.bookingID}}<br/>
                      <b>Start:</b> {{item.start_datetime | formatDateTimeSmall(item.timezone)}}<br/>
                      <b>Finish:</b> {{item.finish_datetime | formatDateTimeSmall(item.timezone)}}
                    </div>
                  </div>
                </span>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-else>
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>

  </div>

</template>
<script>
import {get_tbn_drivers_util_weekly} from '../networking/tbn_apis'
import {mapState} from "vuex"
import {justDate} from '../helpers/dates'
import moment from 'moment'

export default {
  name: 'planned_drivers_weekly_util_tbn',

  components: {
  },

  data() {
    return {
      items: [],
      summary: [],
      loading: true,
      details_fromDate: justDate(moment()),
      selected_type: null,
      driver_expanded: null,
      options: {
        format: 'MM-DD-YYYY',
        useCurrent: true,
        minDate: moment().subtract(90, 'days'),
        maxDate: moment().add(90, 'days'),
        keepOpen: false,
        showClear: true,
        showClose: true,
      },
    }
  },
  async created() {
    this.check_features()
  },
  methods: {
    async check_features() {
      this.load_data()
    },
    showHighlightsForDate(movements) {
      for(const item of movements) {
        item.isHighlightsVisible = !item.isHighlightsVisible;
      }
      this.$forceUpdate();
    },
    filter_by_type(type) {
      if (type == null || this.selected_type == type) {
        this.selected_type = null
      } else {
        this.selected_type = type
      }
    },
    showDetailsForDate(movements) {
      for(const item of movements) {
        item.isVisible = !item.isVisible;
      }
      this.$forceUpdate();
    },
    toggle_div(item,field) {
      if (this.driver_expanded == item)
          this.driver_expanded = null;
      else
          this.driver_expanded = item;
      this.$forceUpdate();
    },
    async load_data() {

      this.loading = true
      try {
        const { value: { data = [] }} = await get_tbn_drivers_util_weekly(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
        this.summary = data.summary
        moment.tz.setDefault(this.summary.timezone)
        this.items = data.results
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }

      this.loading = false
    },
    getStyleForDriverID(color) {
      if (color != null)
        return 'border-radius: 10px; background-color:' + color
      return '';
    },
    async shift_detail_graph_date(shift) {
      this.details_fromDate = moment(this.details_fromDate, 'MM-DD-YYYY').add(shift, 'days').format('MM-DD-YYYY');
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.check_features()
      }
    },
    details_fromDate(target_from_date) {
      this.details_fromDate = target_from_date
      this.details_toDate = justDate(moment(target_from_date,'MM-DD-YYYY').add(27, 'days'));
      this.load_data();
    }
  }
}
</script>

<style>
.arrows {font-size: 22px; font-weight: bold; color: var(--fi-rail-accent) !important }
</style>
